<template>
  <v-navigation-drawer v-model="showSideNav" absolute temporary>
    <template v-if="loggedInUser">
      <v-list-item>
        <v-list-item-icon>
          <v-icon left>mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ loggedInUser.displayName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>
    </template>

    <v-list dense>
      <v-list-item link v-for="item in menuItems" :key="item.title" :to="item.link">
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-if="loggedInUser">
        <v-list-item link @click="routeToProfile">
          <v-list-item-icon>
            <v-icon>mdi-account-cog-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Profil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-else>
        <v-list-item link to="/anmelden">
          <v-list-item-icon>
            <v-icon>mdi-login-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Anmelden</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: "SideNav",
    data() {
      return {
        showSideNav: false,
      }
    },
    created() {
      this.$parent.$on('show-side-nav', () => this.showSideNav = true);
    },
    methods: {
      routeToProfile() {
        this.$emit('route-to-profile')
      },
      logout() {
        this.$emit('logout')
      }
    },
    props: {
      menuItems: {
        type: Array,
        required: true
      },
      loggedInUser: {
        type: Object,
        required: false,
        default: undefined
      }
    }
  }
</script>
